// The deployment's sign-in provider (BOARD_SIGNIN_PROVIDER), stamped on <html data-signin> by the
// API (api/board/routes/spa.py) and in dev by Vite (web/pwa.ts). The signed-out page names it and
// links to its /auth/<provider>/start; Admin's copy names whose email an invite takes.

export type SignInProvider = 'terica' | 'assistant';

const PROVIDERS: Record<SignInProvider, { name: string; button: string; email: string }> = {
  terica: { name: 'terica', button: 'Sign in with terica', email: 'terica email' },
  assistant: { name: 'the Assistant', button: 'Sign in with the Assistant', email: 'Assistant email' },
};

export function signInProvider(): SignInProvider {
  const p = typeof document === 'undefined' ? undefined : document.documentElement.dataset.signin;
  return p === 'assistant' ? 'assistant' : 'terica';
}

/** "terica" / "the Assistant", mid-sentence. */
export function signInProviderName(provider: SignInProvider = signInProvider()): string {
  return PROVIDERS[provider].name;
}

/** "Sign in with terica" / "Sign in with the Assistant". */
export function signInLabel(provider: SignInProvider = signInProvider()): string {
  return PROVIDERS[provider].button;
}

/** "terica email" / "Assistant email": the address the provider knows a person by. */
export function signInEmailLabel(provider: SignInProvider = signInProvider()): string {
  return PROVIDERS[provider].email;
}
